import cx from "classnames";
import s from "./WelcomeBack.module.scss";
import includes from "lodash/includes";
import { getPlatforms, IonLabel, IonPage } from "@ionic/react";
import { ProgressBar } from "./ProgressBar";
import webIosPhoneImg from "../../assets/images/v2RedirectDownload/web_ios_phone.png";
import webAndroidPhoneImg from "../../assets/images/v2RedirectDownload/web_android_phone.png";
import qrCode from "../../assets/images/app-qr-code.png";
import MobileRedirect from "./Mobile/MobileRedirect";
import { useWindowSize } from "react-use";
import { isMacOs, useBreakpoint } from "../../../Common/utils/common";

const SMALL_LAPTOP_VIEW_HEIGHT = 1340;

const RedirectDownload = () => {
  const breakpoint = useBreakpoint();
  const { height } = useWindowSize();
  const platforms = getPlatforms();
  const showWebAndroid = includes(platforms, "android") && !isMacOs();

  return breakpoint !== "laptop" ? (
    <IonPage>
      <div className={s.welcomeback}>
        <MobileRedirect />
      </div>
    </IonPage>
  ) : (
    <IonPage>
      <div className={s.welcomeback}>
        <div className={cx(s.downloadAppContentSuccess)}>
          <div
            className={cx(s.content, {
              [s.clampHeight]: height <= SMALL_LAPTOP_VIEW_HEIGHT,
            })}
          >
            <ProgressBar />
            <div className={s.textImgContents}>
              <div className={s.textContent}>
                <div className={s.headerCntr}>
                  <IonLabel className={cx(s.textHeader)}>WELCOME</IonLabel>
                  <IonLabel className={cx(s.textHeader)}>BACK!</IonLabel>
                </div>
                <IonLabel className={s.textSubHeader}>
                  By downloading our app you will unlock{" "}
                  <span>FREE BONUS ENTRIES</span> <br />+{" "}
                  <span>Heaps more!</span>
                </IonLabel>
                <div className={s.heapsCntr}>
                  <IonLabel className={cx(s.heapsText, s.header)}>
                    The heaps more part:
                  </IonLabel>
                  <ul>
                    <li>
                      <IonLabel className={cx(s.heapsText)}>
                        Get bonus entries just for downloading the app
                      </IonLabel>
                    </li>
                    <li>
                      <IonLabel className={cx(s.heapsText)}>
                        Track everything - entries, wins, upcoming draws & more
                      </IonLabel>
                    </li>
                    <li>
                      <IonLabel className={cx(s.heapsText)}>
                        Redeem Locker Points for rewards and savings
                      </IonLabel>
                    </li>
                    <li>
                      <IonLabel className={cx(s.heapsText)}>
                        Auto entries into all major prize draws
                      </IonLabel>
                    </li>
                    <li>
                      <IonLabel className={cx(s.heapsText)}>
                        Play games to score bonus entries, points, and cash
                      </IonLabel>
                    </li>
                  </ul>
                </div>
              </div>
              <div className={s.photoAndQr}>
                <div className={s.photoContainer}>
                  <img
                    className={cx(s.phoneContent)}
                    src={showWebAndroid ? webAndroidPhoneImg : webIosPhoneImg}
                    alt=""
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className={s.scanCodeContainer}>
                  <img className={s.scanQrCode} src={qrCode} alt="" loading="lazy" decoding="async" />
                  <IonLabel className={s.scanText}>
                    Scan here to download
                  </IonLabel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </IonPage>
  );
};

export default RedirectDownload;
